// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopOffensesControllerGetAllData } from './EshopOffensesControllerGetAllData.gen';
import type { EshopOffensesControllerGetAllErrors } from './EshopOffensesControllerGetAllErrors.gen';
import type { EshopOffensesControllerGetAllOffenseTypesData } from './EshopOffensesControllerGetAllOffenseTypesData.gen';
import type { EshopOffensesControllerGetAllOffenseTypesErrors } from './EshopOffensesControllerGetAllOffenseTypesErrors.gen';
import type { EshopOffensesControllerGetAllOffenseTypesResponses } from './EshopOffensesControllerGetAllOffenseTypesResponses.gen';
import type { EshopOffensesControllerGetAllResponses } from './EshopOffensesControllerGetAllResponses.gen';
import type { EshopOffensesControllerGetOffenseTypeByIdData } from './EshopOffensesControllerGetOffenseTypeByIdData.gen';
import type { EshopOffensesControllerGetOffenseTypeByIdErrors } from './EshopOffensesControllerGetOffenseTypeByIdErrors.gen';
import type { EshopOffensesControllerGetOffenseTypeByIdResponses } from './EshopOffensesControllerGetOffenseTypeByIdResponses.gen';
import type { Options } from './Options.gen';

export class EshopOffensesController {
    /**
     * Get offenses.
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<EshopOffensesControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopOffensesControllerGetAllResponses, EshopOffensesControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/offenses',
            ...options
        });
    }
    
    /**
     * Get offense types.
     */
    public static getAllOffenseTypes<ThrowOnError extends boolean = false>(options?: Options<EshopOffensesControllerGetAllOffenseTypesData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopOffensesControllerGetAllOffenseTypesResponses, EshopOffensesControllerGetAllOffenseTypesErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/offenses/types',
            ...options
        });
    }
    
    /**
     * Get offense type by id.
     */
    public static getOffenseTypeById<ThrowOnError extends boolean = false>(options: Options<EshopOffensesControllerGetOffenseTypeByIdData, ThrowOnError>) {
        return (options.client ?? client).get<EshopOffensesControllerGetOffenseTypeByIdResponses, EshopOffensesControllerGetOffenseTypeByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/offenses/types/{id}',
            ...options
        });
    }
}
